import React, { PureComponent } from 'react'
import PlaybookItem from '../components/playbookItem'
import { Row, Col } from 'reactstrap'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withApollo } from 'react-apollo';
import Tour from '../Tour'
import mockData from '../../../../utils/mockData';
import TourNotActive from '../../TourNotActive';

class TourRecommendation extends PureComponent {
  state = {
    playbookData: mockData.hipaaPlaybook(),
    loadedPlaybook: false,
    loadingPlaybook: true
  }

  render() {
    const {toggleTour} = this.props;
    return (
      <div>
      { toggleTour.toggleOn ? <div className="playbook-container">
         <Tour/>
          <React.Fragment>
            <Row>
              <Col md={12}>
                <h3 className='page-title'>Posture Compliance Playbook</h3>
                <h3 className='page-subhead subhead'>Your custom recommendations to hit your compliance goals.</h3>
              </Col>
            </Row>
            <Row>
              {this.state.playbookData.map((recommendation, i) => {
                  return <PlaybookItem
                    key={uuid()}
                    stepNumber={i + 1}
                    title={recommendation.title}
                    description={recommendation.description}
                    rules={recommendation.rules}
                  />
                })
              }
            </Row>
          </React.Fragment> 
        </div> : <TourNotActive/> }
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    toggleTour: state.toggleTour
  }
}

export default withApollo(connect(mapStateToProps)(withRouter(TourRecommendation)))



// WEBPACK FOOTER //
// ./src/components/tour/playbook/hipaa/TourHipaaPlaybook.js